/* lua.js generated code 0.3.0 */

var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var HomeSceneInfoBanner = xClass("HomeSceneInfoBanner", cc.Node)
var winSize = cc.Director.getInstance().getWinSize()
var STAR_GROUP = table(
    [1, "DOWN", table(12, 51)],
    [1, "UP", table(0, 11)],
    [1, "NORMAL", table(52, 137)],
    [1, "GET", table(138, 163)],
    [1, "GETABLE", table(164, 235)]
)
HomeSceneBannerComponents = table(
    [1, "kEnergy", 1],
    [1, "kStar", 2],
    [1, "kCash", 3],
    [1, "kCoin", 4]
)
HomeSceneInfoBanner.prototype.ctor = function (homeScene, noNeedGetableAnim, canClick = true) {
    var self = this
    cc.Node.prototype.ctor.call(self)
    self.components = table()
    self.lockedCoin = 0
    self.lockedCash = 0
    self.init(homeScene, noNeedGetableAnim, canClick)
}

let bannerBgNormalHeight = 170 + _safe_area_top
let bannerBgLossEnergyHeight = 174 + _safe_area_top
let energyProgressWidthStart = 20
let energyProgressFullWidth = 105
HomeSceneInfoBanner.prototype.init = function (homeScene, noNeedGetableAnim, canClick) {
    var self = this
    self.homeScene = homeScene
    self.canClick = canClick
    self.noNeedGetableAnim = noNeedGetableAnim
    self.isStarGroupOpen = false;   // H5不开星图
    self.bannerEleContainer = cc.Node.create()
    self.addChild(self.bannerEleContainer)
    self.bannerEleContainer.setPositionY(-_safe_area_top)
    // banner_bg = ccui.Scale9Sprite.createWithSpriteFrameName("homeScene/mapuibasicmaterial.png", cc.rect(10, 10, 700, 20))
    // let banner_bg = ccui.Scale9Sprite.createWithSpriteFrameName("homeScene/info_banner_bg.png", cc.rect(10, 10, 700, 20))
    let banner_bg = ccui.Scale9Sprite.createWithSpriteFrameName("homeScene/infobanner_cloud.png", cc.rect(10, 10, 700, 5))
    banner_bg.setContentSize(cc.size(720, bannerBgNormalHeight))
    banner_bg.setAnchorPoint(0.5, 1)
    banner_bg.setPosition(winSize.width / 2, winSize.height + _safe_area_top + 70)
    self.bannerEleContainer.addChild(banner_bg)
    self.banner_bg = banner_bg
    self.energy_btn = cc.CSLoader.createNode("cocos/homeScene_energy_btn.csb")
    self.energy_btn.setPosition(320, winSize.height - 55)
    self.bannerEleContainer.addChild(self.energy_btn)
    self.components[HomeSceneBannerComponents.kEnergy] = self.energy_btn
    let energyBg = cc.Sprite.createWithSpriteFrameName("homeScene/info_banner_btn_bg.png")
    self.energy_btn.addChild(energyBg, -3, "bg")
    energyBg.setPosition(70, 22)
    let energyAddBtn = cc.Sprite.createWithSpriteFrameName("homeScene/info_banner_btn_plus.png")
    self.energy_btn.addChild(energyAddBtn, -1, "add_btn")
    energyAddBtn.setPosition(114, 25)
    let energyProgressBg = ccui.Scale9Sprite.createWithSpriteFrameName("homeScene/energy_progress.png", cc.rect(12, 14, 9, 5))
    energyProgressBg.setAnchorPoint(0, 0)
    energyProgressBg.setContentSize(energyProgressWidthStart, 32)
    energyProgressBg.y = 10
    self.energyProgress = energyProgressBg
    self.energy_btn.addChild(energyProgressBg, -2, "progress")

    self.cash_btn = cc.CSLoader.createNode("cocos/homeScene_cash_btn.csb")
    self.cash_btn.setPosition(20, winSize.height - 55)
    self.bannerEleContainer.addChild(self.cash_btn)
    // self.cash_btn.getChildByName("add_btn").setLocalZOrder(5)
    self.components[HomeSceneBannerComponents.kCash] = self.cash_btn
    let cashBg = cc.Sprite.createWithSpriteFrameName("homeScene/info_banner_btn_bg.png")
    self.cash_btn.addChild(cashBg, -1, "bg")
    cashBg.setPosition(70, 22)
    let cashAddBtn = cc.Sprite.createWithSpriteFrameName("homeScene/info_banner_btn_plus.png")
    self.cash_btn.addChild(cashAddBtn, -1, "add_btn")
    cashAddBtn.setPosition(114, 25)

    self.coin_btn = cc.CSLoader.createNode("cocos/homeScene_coin_btn.csb")
    self.coin_btn.setPosition(180, winSize.height - 55)
    self.bannerEleContainer.addChild(self.coin_btn)
    self.components[HomeSceneBannerComponents.kCoin] = self.coin_btn
    // let coinBg = ccui.Scale9Sprite.createWithSpriteFrameName("homeScene/info_banner_btn_bg.png", cc.rect(15, 10, 120, 20))
    let coinBg = cc.Sprite.createWithSpriteFrameName("homeScene/info_banner_btn_bg.png")
    // coinBg.setContentSize(150, 42)
    coinBg.setScaleX(1.2)
    self.coin_btn.addChild(coinBg, -1, "bg")
    coinBg.setPosition(50, 22)
    let coinAddBtn = cc.Sprite.createWithSpriteFrameName("homeScene/info_banner_btn_plus.png")
    self.coin_btn.addChild(coinAddBtn, -1, "add_btn")
    coinAddBtn.setPosition(104, 25)

    self.energyLabel = cc.Label.createWithBMFont("font/berlinsansfb_30_bluestroke.fnt", "0", cc.TEXT_ALIGNMENT_CENTER)
    // self.energyLabel = cc.Label.createWithBMFont("font/berlin_sans_fb_demi_25_blue.fnt", "0", cc.TEXT_ALIGNMENT_CENTER)
    // self.energyLabel = cc.LabelTTF.create('0', FONT_DEF.microsoftYahei_25_blueBlueStroke)
    self.energyLabel.setScale(25/30)
    self.energyLabel.setPosition(65, 23.5)
    self.energyLabel.setAdditionalKerning(-4)
    self.energy_btn.addChild(self.energyLabel)
    self.energyTimeLabel = cc.Label.createWithBMFont("font/berlinsansfb_30_bluestroke.fnt", "", cc.TEXT_ALIGNMENT_CENTER) 
    // self.energyTimeLabel = cc.Label.createWithBMFont("font/zzgftongxin_20_bluestroke.fnt", "", cc.TEXT_ALIGNMENT_CENTER)
    // self.energyTimeLabel = cc.LabelTTF.create('', FONT_DEF.microsoftYahei_24_blueStroke)
    self.energyTimeLabel.setPosition(55, -8)
    // self.energyTimeLabel.setScale(0.6)
    self.energyTimeLabel.setScale(0.6 * 25 / 22)
    self.energy_btn.addChild(self.energyTimeLabel)
    self.cashNumLabel = cc.Label.createWithBMFont("font/berlinsansfb_30_bluestroke.fnt", "0", cc.TEXT_ALIGNMENT_CENTER)
    self.cashNumLabel.setScale(25/30)
    self.cashNumLabel.setPosition(70, 21)
    self.cashNumLabel.setAdditionalKerning(-4)
    self.cash_btn.addChild(self.cashNumLabel)
    // self.coinNumLabel = cc.LabelTTF.create('0', FONT_DEF.microsoftYahei_24_blueStroke)
    self.coinNumLabel = cc.Label.createWithBMFont("font/berlinsansfb_30_bluestroke.fnt", "0", cc.TEXT_ALIGNMENT_CENTER)
    self.coinNumLabel.setScale(25/30)
    // self.coinNumLabel = cc.Label.createWithBMFont("font/zzgftongxin_20_bluestroke.fnt", "0", cc.TEXT_ALIGNMENT_CENTER)

    self.coinNumLabel.setPosition(58, 21)
    self.coinNumLabel.setAnchorPoint(0.5, 0.5)
    self.coinNumLabel.setAdditionalKerning(-4)
    self.coinNumLabel.setScale(25 / 30)
    self.coin_btn.addChild(self.coinNumLabel)
    // self.star_group_btn = cc.CSLoader.createNode("cocos/homeSceneBall_home_scene_ball.csb")

    // 去除星图有时候出现的白线
    // var circle_progress = cc.ProgressTimer.create(cc.Sprite.createWithSpriteFrameName("homeSceneBall/circle_progress.png"))
    // circle_progress.setType(cc.PROGRESS_TIMER_TYPE_RADIAL)
    // circle_progress.setReverseDirection(true)
    // circle_progress.setMidpoint(cc.p(0.5, 0.5))
    // circle_progress.setPercentage(100)
    // circle_progress.setPosition(70.5, 70.5)
    // circle_progress.setRotation(-43)
    // self.star_group_btn.getChildByName("a10").addChild(circle_progress)
    // self.star_group_btn.circle_progress = circle_progress
    // var circle_progress_frame = cc.Sprite.createWithSpriteFrameName("homeSceneBall/circle_progress_frame.png")
    // circle_progress_frame.setAnchorPoint(1, 0)
    // circle_progress_frame.setPosition(70.5, 70.5)
    // self.star_group_btn.getChildByName("a10").addChild(circle_progress_frame)
    // self.star_group_btn.circle_progress_frame = circle_progress_frame
    // var label = cc.Label.createWithBMFont("font/berlin_sans_fb_demi_25_blue.fnt", "100")
    // label.setPosition(13, 8)
    // self.star_group_btn.getChildByName("txtnumb").removeAllChildren(true)
    // self.star_group_btn.getChildByName("txtnumb").addChild(label)
    // self.star_group_btn.circle_progress_label = label
    // var action = cc.CSLoader.createTimeline("cocos/homeSceneBall_home_scene_ball.csb")
    // self.star_group_btn.runAction(action)
    // self.star_group_btn.action = action
    // self.star_group_btn.setPosition(winSize.width / 2, winSize.height - 70 - _safe_area_top)
    // self.addChild(self.star_group_btn)
    // self.updateStarBallAfterPassLevel()
    self.energy_scale9 = self.energy_btn.getChildByName("bg")
    self.energy_scale9_icon_pos = cc.p(11, 24)
    self.cash_scale9 = self.cash_btn.getChildByName("bg")
    self.cash_scale9_icon_pos = cc.p(15, 23)
    self.coin_scale9 = self.coin_btn.getChildByName("bg")
    self.coin_scale9_icon_pos = cc.p(0, 23)
    self.isNodeExist = true

    // if (isWechatGameEnv()) {
        // 星图不变方案
        // self.energy_btn.setScale(0.9)
        // self.cash_btn.setScale(0.9)
        // self.coin_btn.setScale(0.9)
        // self.energy_btn.setPosition(30, winSize.height - 55)
        // self.cash_btn.setPosition(180, winSize.height - 55)
        // self.coin_btn.setPosition(460, winSize.height - 55)
        // 星图放在左上角方案
        // self.star_group_btn.setPosition(self.star_group_btn.circle_progress._contentSize.width / 2 - 15, winSize.height - self.star_group_btn.circle_progress._contentSize.height / 2 - 15)
        // self.energy_btn.setScale(0.9)
        // self.cash_btn.setScale(0.9)
        // self.coin_btn.setScale(0.9)
        // self.energy_btn.setPosition(140, winSize.height - 55)
        // self.cash_btn.setPosition(290, winSize.height - 57)
        // self.coin_btn.setPosition(430, winSize.height - 58)
    // }

    function callbackAsyned() {
        if (!self.isNodeExist) {
            return 
        }
        var icon = self.energy_btn.getChildByName("icon")
        if (icon) {
            // icon.setVisible(false)
            icon.removeFromParent(true)
        }
        var icon = self.cash_btn.getChildByName("icon")
        if (icon) {
            // icon.setVisible(false)
            icon.removeFromParent(true)
        }
        var icon = self.coin_btn.getChildByName("icon")
        if (icon) {
            // icon.setVisible(false)
            icon.removeFromParent(true)
        }
        FrameLoader.loadImageWithPlist("cocos/properties.plist")
        var energy = cc.Sprite.createWithSpriteFrameName("properties/prop_4.png")
        energy.setName("icon")
        energy.setScale(0.4)
        energy.setPosition(self.energy_scale9_icon_pos)
        self.energy_btn.addChild(energy)
        var cash = cc.Sprite.createWithSpriteFrameName("properties/prop_14.png")
        cash.setName("icon")
        cash.setScale(0.4)
        cash.setPosition(self.cash_scale9_icon_pos)
        self.cash_btn.addChild(cash)
        var coin = cc.Sprite.createWithSpriteFrameName("properties/prop_2.png")
        coin.setName("icon")
        coin.setScale(0.4)
        coin.setPosition(self.coin_scale9_icon_pos)
        self.coin_btn.addChild(coin)
    }

    // FIXME: AsyncLoader
    // AsyncLoader.getInstance().waitingForLoadComplete(callbackAsyned)
    callbackAsyned();
    
    // var [ProgressBar, ProgressBarDirection] = unpack(require("clover/panel/component/common/ProgressBar"))
    // self.energyBar = ProgressBar.create(self.energy_btn.getChildByName("progress"), ProgressBarDirection.kLeftToRight)
    var InfiniteEnergyBar = require("clover/scene/component/homescene/InfiniteEnergyBar")
    var infiniteNode = self.energy_btn.getChildByName("progress_if")
    self.infiniteEnergyBar = InfiniteEnergyBar.create(infiniteNode)
    self.infiniteEnergyBar.setScale(1)
    self.infiniteEnergyBar.setPosition(0, 44)
    self.isOpeningSG = false
    var energyBtnNode = cc.Node.create()
    var oldBtnNode = self.energy_btn.getChildByName("bg")
    var oldSize = oldBtnNode.getContentSize()
    energyBtnNode.setContentSize(cc.size(oldSize.width / 2, oldSize.height))
    energyBtnNode.setPosition(oldBtnNode.getPosition())
    energyBtnNode.setAnchorPoint(-0.25, 0.4)
    self.energy_btn.addChild(energyBtnNode)
    var btn = UIButton.create(self.energy_btn.getChildByName("bg"), true)
    btn.on(UIButtonEvent.Click, function () {
        if (!self.canClick){
            return
        }
        DCAssist.dc4User101("energy_ad","energy_bar_click",{session: AdEnergyManager.getInstance().createDCSession()})
        self.onClickEnergy()
    })
    self.energyBtn = btn
    var addBtn = self.energy_btn.getChildByName("add_btn")
    addBtn.setAnchorPoint(0.5, 0.5)
    ButtonPushBounceAnim.create(self.energyBtn, addBtn)

    btn = UIButton.create(self.cash_btn.getChildByName("bg"), true)
    self.cashBtn = btn
    let snsProxy = require("clover/sns/SnsProxy").getInstance();
    if (MetaManager.isSupportCash() || snsProxy.allowAd() || snsProxy.allowShare()) {
        var addBtn2 = self.cash_btn.getChildByName("add_btn")
        addBtn2.setAnchorPoint(0.5, 0.5)
        ButtonPushBounceAnim.create(self.cashBtn, addBtn2)
        btn.on(UIButtonEvent.Click, function () {
            if (!self.canClick){
                return
            }
            self.onClickCash()
        })
    } else {
        self.cash_btn.getChildByName("add_btn").setVisible(false)
    }
    
    // var btn3 = UIButton.create(self.coin_btn, true)
    // btn3.on(UIButtonEvent.Click, function () {
    //     self.onClickCoin()
    // })
    // self.coinBtn = btn3
    self.coinClickTime = 0
    btn = UIButton.create(self.coin_btn.getChildByName("bg"), true)
    self.coinBtn = btn
    var addBtn3 = self.coin_btn.getChildByName("add_btn")
    addBtn3.setAnchorPoint(0.5, 0.5)
    ButtonPushBounceAnim.create(self.coinBtn, addBtn3)
    btn.on(UIButtonEvent.Click, function () {
        if (!self.canClick){
            return
        }
        self.onClickCoin()
    })
    // function onNodeEvent(event) {
    //     if (event === "enter") {
    //         self.startTimer()
    //     } else if (event === "exit") {
    //         self.stopTimer()
    //     }
    // }
    //self.registerScriptHandler(onNodeEvent)
}
HomeSceneInfoBanner.prototype.onEnter = function () {
    cc.Node.prototype.onEnter.call(this)
    this.startTimer()
}
HomeSceneInfoBanner.prototype.onExit = function () {
    cc.Node.prototype.onExit.call(this)    
    this.stopTimer()
}
HomeSceneInfoBanner.prototype.startTimer = function () {
    var self = this
    function scheduleCountdown() {
        self.updateView()
    }
    self.timerId = cc.Director.getInstance().getScheduler().scheduleScriptFunc(scheduleCountdown, 1, false)
}
HomeSceneInfoBanner.prototype.stopTimer = function () {
    var self = this
    if (self.timerId) {
        cc.Director.getInstance().getScheduler().unscheduleScriptEntry(self.timerId)
        self.timerId = null
    }
}
HomeSceneInfoBanner.prototype.getEnergyPosition = function () {
    var self = this
    var pos = self.energy_btn.convertToWorldSpace(cc.p(self.energyLabel.getPositionX(), self.energyLabel.getPositionY()))
    if (self.isStarGroupOpen) {
        pos.y = pos.y - 70
    }
    return pos
}
HomeSceneInfoBanner.prototype.getEnergyIconPositon = function () {
    var self = this
    // body
    // WARN: maybe multi result
    return self.energy_btn.convertToWorldSpace(self.energy_scale9_icon_pos)
}
HomeSceneInfoBanner.prototype.getCoinPosition = function () {
    var self = this
    var pos = self.coin_btn.convertToWorldSpace(self.coin_scale9_icon_pos)
    if (self.isStarGroupOpen) {
        pos.y = pos.y - 70
    }
    return pos
}
HomeSceneInfoBanner.prototype.getCashPosition = function () {
    var self = this
    var pos = self.cash_btn.convertToWorldSpace(self.cash_scale9_icon_pos)
    if (self.isStarGroupOpen) {
        pos.y = pos.y - 70
    }
    return pos
}
HomeSceneInfoBanner.prototype.getStarGroupPosition = function () {
    var self = this
    var {x: posX, y: posY} = self.star_group_btn.getPosition()
    posX = posX + self.star_group_btn.getContentSize().width / 2
    posY = posY - self.star_group_btn.getContentSize().height / 2
    // WARN: maybe multi result
    return self.convertToWorldSpace(cc.p(posX, posY))
}
HomeSceneInfoBanner.prototype.setComponentVisible = function (comp, visible) {
    var self = this
    if (self.components[comp]) {
        self.components[comp].setVisible(visible)
    }
}
HomeSceneInfoBanner.prototype.setTouchEnabled = function (enable) {
    var self = this
    self.coinBtn.setEnabled(enable)
    self.cashBtn.setEnabled(enable)
    self.energyBtn.setEnabled(enable)
}
HomeSceneInfoBanner.prototype.dispose = function () {
    var self = this
    self.stopTimer()
}
HomeSceneInfoBanner.prototype.onClickEnergy = function () {
    var self = this
    // require("clover/panel/EnergyPanel").create(0).popup(true)
    require.ensure([], () => {
        require("clover/panel/EnergyPanel").show(0)
    }, null, 'act')
}
HomeSceneInfoBanner.prototype.onClickCash = function () {
    var self = this
    // 微信ios的商店涉及到审核，有特殊的标志需要读取
    let isWechatgameIOS = window.mini && mini.getOS() == MiniOS.IOS && mini.getPlatform() == MiniPlatform.wechatGame
    let um = UserManager.getInstance()
    if((isWechatgameIOS && um.canIconShow("shop_ios_wechatgame")) || (!isWechatgameIOS && um.canIconShow("shop"))) {
        MarketManager.getInstance().showMarketPanel()
    } else {
        // 临时解决方案
        Toast.make("敬请期待")
    }
}
HomeSceneInfoBanner.prototype.onClickCoin = function () {
    var self = this
    require("clover/panel/CoinNotEnoughPanel").show(true, function () {

    }) 
    DCAssist.userTrack("user_click", "home_scence", {feature: "coins"});
}
//调整一下energy bar的长度
function getProcess(percent) {
    // return percent ^ 0.7 * 100
    // FIXME: length
    return percent * 100
}
function convertCash(num) {
    num = tonumber(num) || 0
    if (num >= 100000) {
        return Math.floor(num / 10000) + "万"
    }
    return num
}
function convertCoin(num) {
    num = tonumber(num) || 0
    if (num > 9999) {
        // num -= num % 100
        // return  (num / 10000) + "万"
        // if (num > 99999999) {
        //     //  TODO    字体中还没加入"亿"字，使用 berlinsansfb_30_bluestroke (不好加，如果必须要改的时候，让美术换字体吧)
        //     return Math.floor(num / 100000000) + "亿"
        // }
        return Math.floor(num / 10000) + "万"
    }
    return num
}
HomeSceneInfoBanner.prototype.updateView = function () {
    var self = this
    var [infiniteEnergy, leftTime] = UserEnergy.getInstance().getEnergyInfinity()
    if (infiniteEnergy) {
        self.infiniteEnergyBar.setVisible(true)
        self.energyLabel.setString(UIUtils.formatTime(leftTime))
        self.energyTimeLabel.setString("")
        self.energyLabel.x = 75
    } else {
        self.infiniteEnergyBar.setVisible(false)
        self.energyLabel.x = 65
        var [currentEnergy, recoverTime] = UserEnergy.getInstance().getEnergy()
        var energyLimit = UserEnergy.getInstance().getEnergyLimit()
        self.energyLabel.setString(currentEnergy + "/" + energyLimit)
        // self.energyBar.setPercent(getProcess(currentEnergy / energyLimit))
        if (recoverTime) {
            var eps = MetaManager.getInstance().global.user_energy_recover_time_unit || 480000
            var t = Math.floor((recoverTime % eps) / 1000)
            var m = Math.floor(t / 60)
            t = t % 60
            self.energyTimeLabel.setString(string.format("%02d:%02d后+1", m, t))
            if (self.banner_bg._contentSize.height !== bannerBgLossEnergyHeight) {
                self.banner_bg.setContentSize(720, bannerBgLossEnergyHeight)
            }
        } else {
            self.energyTimeLabel.setString("")
            if (self.banner_bg._contentSize.height !== bannerBgNormalHeight) {
                self.banner_bg.setContentSize(720, bannerBgNormalHeight)
            }
        }
        let energyProgressWidth = currentEnergy / energyLimit * energyProgressFullWidth + energyProgressWidthStart
        let currWidth = self.energyProgress._contentSize.width
        if (Math.abs(energyProgressWidth - currWidth) > 0.001) {
            self.energyProgress.setContentSize(energyProgressWidth, self.energyProgress._contentSize.height)
        }
    }
    self.cashNumLabel.setString(convertCash(Math.max(UserCash.getInstance().getCash() - self.lockedCash, 0)))
    self.coinNumLabel.setString(convertCoin(Math.max(UserCoin.getInstance().getCoin() - self.lockedCoin, 0)))
    
    //精力达到上限，隐藏气泡
    var energyLimit = UserEnergy.getInstance().getEnergyLimit()
    if (UserEnergy.getInstance().checkEnergy(energyLimit)){
        self.hideEnergyAdTips()
    }


    self.updateViewCb && self.updateViewCb()
}
HomeSceneInfoBanner.prototype.onStarGroupOpen = function (onCallBack) {
    var self = this
    var actionList = table()
    table.insert(actionList, cc.MoveBy.create(5 / 30, cc.p(0, 70)))
    table.insert(actionList, cc.DelayTime.create(3 / 30))
    if (onCallBack) {
        table.insert(actionList, cc.CallFunc.create(onCallBack))
    }
    self.bannerEleContainer.runAction(cc.Sequence.create(actionList))
    // self.star_group_btn.action.gotoFrameAndPlay(STAR_GROUP.UP[1], STAR_GROUP.UP[2], false)
    // self.star_group_btn.action.setLastFrameCallFunc(function () {
    //     self.star_group_btn.action.clearLastFrameCallFunc()
    //     self.bannerEleContainer.setVisible(false)
    // })
    self.isStarGroupOpen = true
}
HomeSceneInfoBanner.prototype.onStarGroupClose = function (onCallBack) {
    var self = this
    var actionList = table()
    table.insert(actionList, cc.CallFunc.create(function () {
        self.bannerEleContainer.setVisible(true)
    }))
    table.insert(actionList, cc.MoveBy.create(5 / 30, cc.p(0, -70)))
    self.bannerEleContainer.runAction(cc.Sequence.create(actionList))
    self.isStarGroupOpen = null
}
HomeSceneInfoBanner.prototype.updateStarBallAfterPassLevel = function () {}
HomeSceneInfoBanner.prototype.lockCoin = function (value) {
    var self = this
    self.lockedCoin = self.lockedCoin + value
}
HomeSceneInfoBanner.prototype.releaseCoin = function (value) {
    var self = this
    self.lockedCoin = Math.max(self.lockedCoin - value, 0)
}
HomeSceneInfoBanner.prototype.lockCash = function (value) {
    var self = this
    self.lockedCash = self.lockedCash + value
}
HomeSceneInfoBanner.prototype.releaseCash = function (value) {
    var self = this
    self.lockedCash = Math.max(self.lockedCash - value, 0)
}
HomeSceneInfoBanner.prototype.showInOtherScene = function (onCallBack) {
    var self = this
    self.updateView()
    self.bannerEleContainer.setPositionY(70)
    self.bannerEleContainer.setVisible(false)
    self.onStarGroupClose(onCallBack)
    var layerColor = cc.LayerColor.create(cc.c4b(0, 0, 0, 0), winSize.width, 150)
    function onCall(event) {
        var pos = layerColor.convertToNodeSpace(cc.p(event.x, event.y))
        var rect = cc.rect(0, 0, winSize.width, 150)
        if (cc.rectContainsPoint(rect, pos)) {
            return true
        }
        return false
    }
    layerColor.setPositionY(winSize.height - 150)
    layerColor.onTouch(onCall, null, true)
    self.addChild(layerColor)
}
HomeSceneInfoBanner.prototype.hideInOtherScene = function (onCallBack) {
    var self = this
    function callback() {
        self.onStarGroupOpen(onCallBack)
    }
    self.playGetStarAnim(callback)
}
HomeSceneInfoBanner.prototype.onHit = function () {
    var self = this
    self.playGetStarAnim()
}
HomeSceneInfoBanner.prototype.getGoTop = function (onCallBack) {
    var self = this
    self.onStarGroupOpen(onCallBack)
}
HomeSceneInfoBanner.prototype.playGetStarAnim = function (onCallBack) {}
HomeSceneInfoBanner.prototype.hideStarGroupBTN = function () {
    var self = this
    // self.star_group_btn.setVisible(false)
}
HomeSceneInfoBanner.prototype.showStarGroupBTN = function () {
    var self = this
    // self.star_group_btn.setVisible(true)
}

HomeSceneInfoBanner.prototype.showEnergyAdTips = function(){
    var self = this;
    return
    if (!self.energyAdTip){
        self.energyAdTip = cc.CSLoader.createNode("cocos/homeLib_bubble_energy_ad_tips.csb")
        self.energyAdTip.ani = cc.CSLoader.createTimeline("cocos/homeLib_bubble_energy_ad_tips.csb")
        self.energyAdTip.setVisible(true)
        self.energyAdTip.runAction(self.energyAdTip.ani)
        // self.energyAdTip.ani.play("appear", false);
        // self.energyAdTip.ani.setLastFrameCallFunc(function(){
        self.energyAdTip.ani.play("loop", true);
        // })
        // self.energyAdTip.ani.gotoFrameAndPlay(0, true)
        self.energyAdTip.setPosition(200, 20)
        self.energy_btn.addChild(self.energyAdTip)
        
        // 点击tip打开精力面板
        var energyAtTipAera =  cc.LayerColor.create(new cc.Color(255, 0, 0, 0), 150, 40);
        energyAtTipAera.setPosition(-70, -20)
        self.energyAdTip.addChild(energyAtTipAera)
        var btn = UIButton.create(energyAtTipAera, true)
        btn.on(UIButtonEvent.Click, function () {
            if (!self.canClick){
                return
            }
            DCAssist.dc4User101("energy_ad","recover_bubble_click",{session: AdEnergyManager.getInstance().createDCSession()})
            self.onClickEnergy()
        })
       
        DCAssist.dc4User101("energy_ad","recover_bubble_show",{session: AdEnergyManager.getInstance().createDCSession()})
        // energyAtTipAera.setEnabled(false)
    }
    

    if (!self.energyAdTip.visible){
        self.energyAdTip.setVisible(true);
        
        DCAssist.dc4User101("energy_ad","recover_bubble_show",{session: AdEnergyManager.getInstance().createDCSession()})
    }
}
HomeSceneInfoBanner.prototype.hideEnergyAdTips = function(){
    var self = this;
    if (self.energyAdTip){
        self.energyAdTip.setVisible(false);
        // self.energyAdTip = null
    }

}
module.exports = HomeSceneInfoBanner